// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    titleChooseAction: {
        id: 'discover-actions.title-choose-action',
        defaultMessage: 'Showing all action templates'
    },
    titleSpecificTemplates: {
        id: 'discover-actions.title-specific-templates',
        defaultMessage: 'Showing {selected} templates'
    },
    buildYourOwnActions: {
        id: 'discover-actions.build-your-own-actions',
        defaultMessage: 'Build your own actions'
    },
    all: {
        id: 'discover-actions-title.all',
        defaultMessage: 'all'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/discover-actions/filter-title/intl.js